import axios from 'axios';
import { http } from '../http';

export interface UploadResponse {
  url?: string;
  urls?: string[];
}

export const uploadArquivos = async (
  files: File[],
  tipo: string,
  associadoId?: string,
  carroId?: string
): Promise<UploadResponse> => {
  try {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append('files', file);
    });

    formData.append('tipo', tipo);
    if (associadoId) formData.append('associadoId', associadoId);
    if (carroId) formData.append('carroId', carroId);

    const response = await http.post('/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });

    return response.data;
  } catch (error: unknown) {
    if (axios.isAxiosError(error)) {
      throw new Error(error.response?.data?.message || 'Erro ao fazer upload');
    } else {
      throw new Error('Erro desconhecido');
    }
  }
};
